import { store } from 'DashboardUser/store'
import { Provider } from 'react-redux'
import PageContainer from 'DashboardUser/components/PageContainer'

export default function DashboardUser(params) {
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <PageContainer {...params} />
      </ErrorBoundary>
    </Provider>
  )
}
